import { render, staticRenderFns } from "./JwJiaoshiList.vue?vue&type=template&id=fe382fe0"
import script from "./JwJiaoshiList.vue?vue&type=script&lang=js"
export * from "./JwJiaoshiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports